// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YourEditRouteImport } from './routes/your-edit'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SuggestRouteImport } from './routes/suggest'
import { Route as ScanHistoryRouteImport } from './routes/scan-history'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RequestsRouteImport } from './routes/requests'
import { Route as RediscoverRouteImport } from './routes/rediscover'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LooksRouteImport } from './routes/looks'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JewelryRouteImport } from './routes/jewelry'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EcrinEyeRouteImport } from './routes/ecrin-eye'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as ClothingRouteImport } from './routes/clothing'
import { Route as CaileveEyeRouteImport } from './routes/caileve-eye'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AccessoriesRouteImport } from './routes/accessories'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RequestsIndexRouteImport } from './routes/requests.index'
import { Route as RequestsIdRouteImport } from './routes/requests.$id'
import { Route as LooksIndexRouteImport } from './routes/looks.index'
import { Route as LooksNewRouteImport } from './routes/looks.new'
import { Route as LooksIdRouteImport } from './routes/looks.$id'
import { Route as JewelryIndexRouteImport } from './routes/jewelry.index'
import { Route as JewelryIdRouteImport } from './routes/jewelry.$id'
import { Route as ClothingIndexRouteImport } from './routes/clothing.index'
import { Route as ClothingIdRouteImport } from './routes/clothing.$id'
import { Route as AccessoriesIndexRouteImport } from './routes/accessories.index'
import { Route as AccessoriesIdRouteImport } from './routes/accessories.$id'

const YourEditRoute = YourEditRouteImport.update({
            id: '/your-edit',path: '/your-edit',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SuggestRoute = SuggestRouteImport.update({
            id: '/suggest',path: '/suggest',getParentRoute: () => rootRouteImport
          })
const ScanHistoryRoute = ScanHistoryRouteImport.update({
            id: '/scan-history',path: '/scan-history',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RequestsRoute = RequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => rootRouteImport
          })
const RediscoverRoute = RediscoverRouteImport.update({
            id: '/rediscover',path: '/rediscover',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PlansRoute = PlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const LooksRoute = LooksRouteImport.update({
            id: '/looks',path: '/looks',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const JewelryRoute = JewelryRouteImport.update({
            id: '/jewelry',path: '/jewelry',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EcrinEyeRoute = EcrinEyeRouteImport.update({
            id: '/ecrin-eye',path: '/ecrin-eye',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
            id: '/confirm-email',path: '/confirm-email',getParentRoute: () => rootRouteImport
          })
const ClothingRoute = ClothingRouteImport.update({
            id: '/clothing',path: '/clothing',getParentRoute: () => rootRouteImport
          })
const CaileveEyeRoute = CaileveEyeRouteImport.update({
            id: '/caileve-eye',path: '/caileve-eye',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AccessoriesRoute = AccessoriesRouteImport.update({
            id: '/accessories',path: '/accessories',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RequestsIndexRoute = RequestsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RequestsRoute
          })
const RequestsIdRoute = RequestsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => RequestsRoute
          })
const LooksIndexRoute = LooksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LooksRoute
          })
const LooksNewRoute = LooksNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => LooksRoute
          })
const LooksIdRoute = LooksIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LooksRoute
          })
const JewelryIndexRoute = JewelryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JewelryRoute
          })
const JewelryIdRoute = JewelryIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => JewelryRoute
          })
const ClothingIndexRoute = ClothingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ClothingRoute
          })
const ClothingIdRoute = ClothingIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => ClothingRoute
          })
const AccessoriesIndexRoute = AccessoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccessoriesRoute
          })
const AccessoriesIdRoute = AccessoriesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AccessoriesRoute
          })





const AccessoriesRouteChildren = {
  AccessoriesIdRoute: AccessoriesIdRoute,AccessoriesIndexRoute: AccessoriesIndexRoute
}

const AccessoriesRouteWithChildren = AccessoriesRoute._addFileChildren(AccessoriesRouteChildren)




const ClothingRouteChildren = {
  ClothingIdRoute: ClothingIdRoute,ClothingIndexRoute: ClothingIndexRoute
}

const ClothingRouteWithChildren = ClothingRoute._addFileChildren(ClothingRouteChildren)




const JewelryRouteChildren = {
  JewelryIdRoute: JewelryIdRoute,JewelryIndexRoute: JewelryIndexRoute
}

const JewelryRouteWithChildren = JewelryRoute._addFileChildren(JewelryRouteChildren)




const LooksRouteChildren = {
  LooksIdRoute: LooksIdRoute,LooksNewRoute: LooksNewRoute,LooksIndexRoute: LooksIndexRoute
}

const LooksRouteWithChildren = LooksRoute._addFileChildren(LooksRouteChildren)




const RequestsRouteChildren = {
  RequestsIdRoute: RequestsIdRoute,RequestsIndexRoute: RequestsIndexRoute
}

const RequestsRouteWithChildren = RequestsRoute._addFileChildren(RequestsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessoriesRoute: AccessoriesRouteWithChildren,AccountRoute: AccountRoute,CaileveEyeRoute: CaileveEyeRoute,ClothingRoute: ClothingRouteWithChildren,ConfirmEmailRoute: ConfirmEmailRoute,EcrinEyeRoute: EcrinEyeRoute,FaqRoute: FaqRoute,FavoritesRoute: FavoritesRoute,JewelryRoute: JewelryRouteWithChildren,LoginRoute: LoginRoute,LooksRoute: LooksRouteWithChildren,OnboardingRoute: OnboardingRoute,PlansRoute: PlansRoute,PrivacyRoute: PrivacyRoute,RediscoverRoute: RediscoverRoute,RequestsRoute: RequestsRouteWithChildren,ResetPasswordRoute: ResetPasswordRoute,ScanHistoryRoute: ScanHistoryRoute,SuggestRoute: SuggestRoute,TermsRoute: TermsRoute,YourEditRoute: YourEditRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)